import { createContext } from 'react';

import type { TranslationKey } from '@/shared/i18n';
import type { Locale, LOCALE_OPTIONS } from '@/shared/i18n/types';

export interface I18nContextValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: TranslationKey, params?: Record<string, string>) => string;
  localeOptions: typeof LOCALE_OPTIONS;
}

export const I18nContext = createContext<I18nContextValue | null>(null);
